import { __awaiter, __generator } from "tslib";
import { getMediaFileType } from './getMediaFileType';
var MEDIA_SERVICES_URL = '/_serverless/ricos-media-services';
function getDownloadUrl(instance) {
    var _this = this;
    return function (fileId) { return __awaiter(_this, void 0, void 0, function () {
        var params, response, arrURLs;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = new URLSearchParams({ fileId: fileId });
                    return [4 /*yield*/, fetch(MEDIA_SERVICES_URL + "/download-url?" + params.toString(), {
                            headers: { Authorization: instance },
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    arrURLs = (_a.sent());
                    return [2 /*return*/, arrURLs];
            }
        });
    }); };
}
var getDomain = function (mediaType, metaSiteId) {
    var mediaTypeMapper = {
        picture: 'static.wixstatic.com',
        video: 'video.wixstatic.com',
        music: 'music.wixstatic.com',
        document: metaSiteId + ".usrfiles.com",
        archive: metaSiteId + ".usrfiles.com",
    };
    return mediaTypeMapper[mediaType];
};
/**
 * Following media privacy PR (https://github.com/wix-private/wix-ricos/pull/706),
 * Files were uploaded with id=file_name, instead of id=file_url (uploadStrategy.ts).
 * In the general case, file_url = {some_postfix}/{file_name}/{some_prefix}.
 * Resolving `file_name` alone can only be done in our service (`download-url` endpoint).
 * Following this update, files will be uploaded with id=file_url again.
 *
 * This util function fixes small portion of files that were uploaded with id=file_name
 * during this period.
 * @param id fileId stored in fileComponentData
 * @returns whether id has a proper file_url prefix that can be resolved
 */
function idContainsPrefix(id) {
    return id.includes('/');
}
export function resolveFileUrl(metaSiteId, instance) {
    return function (_a) {
        var id = _a.id, type = _a.type, privacy = _a.privacy;
        if (privacy !== 'private' && idContainsPrefix(id)) {
            var domain = getDomain(getMediaFileType(type), metaSiteId);
            return Promise.resolve("https://" + domain + "/" + id);
        }
        else {
            return getDownloadUrl(instance)(id).then(function (urls) { var _a; return Array.isArray(urls) && ((_a = urls[0]) === null || _a === void 0 ? void 0 : _a.path); });
        }
    };
}
//# sourceMappingURL=resolveFileUrl.js.map